import { Box, Button, Flex, HStack, Image, Link, Text } from '@chakra-ui/core';
import { ChevronRightIcon } from '@chakra-ui/icons';
import React from 'react';
import AnyoneImage from '../../../assets/anyone.svg';
import PageImage from '../../../assets/profile.svg';
import TwitterImage from '../../../assets/twitter.svg';

const InfoImage = ({ image, children }) => (
  <Flex flexDir="column">
    <Image src={image} height="150px" />
    <Text fontWeight="bold" mt={4}>
      {children}
    </Text>
  </Flex>
);

const SetupInfluencerInfo = ({ nextPage }) => (
  <Box p={8}>
    <HStack justifyContent="space-around" mb={8}>
      <InfoImage image={PageImage}>
        Dedicated page for your bets and offers
      </InfoImage>

      <InfoImage image={TwitterImage}>
        Share your page publicly on Crypto Twitter
      </InfoImage>
      <InfoImage image={AnyoneImage}>Anyone can accept those bets</InfoImage>
    </HStack>
    <Flex flexDir="row-reverse">
      <Flex flexDir="column">
        <Button
          alignSelf="flex-end"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={nextPage}
          mb={2}
        >
          Create Influencer Page
        </Button>
        <Text fontSize="xs">
          By proceeding, you accept our{' '}
          <Link
            color="blue.600"
            target="_blank"
            href="/odds/app/BetaTermsOfService.html"
          >
            Beta Terms of Service
          </Link>
          ,{' '}
          <Link
            color="blue.600"
            target="_blank"
            href="/odds/app/TermsOfService.html"
          >
            Terms of Service
          </Link>
          , and{' '}
          <Link
            color="blue.600"
            target="_blank"
            href="/odds/app/PrivacyPolicy.html"
          >
            Privacy Policy
          </Link>
        </Text>
      </Flex>
    </Flex>
  </Box>
);

export default SetupInfluencerInfo;
